<template>
  <div class="back-to-home-status mb-2">
    <div
      v-if="!status"
      class="d-flex justify-content-center my-2"
    >
      <b-spinner
        variant="primary"
        label="Loading..."
      />
    </div>
    <b-alert
      v-else-if="!status.is_supported"
      variant="warning"
      class="mb-0"
      show
    >
      <div class="alert-body">
        {{ status.unsupported_reason }}
      </div>
    </b-alert>
    <template v-else>
      <div class="d-flex flex-wrap align-items-center">
        <div class="d-flex align-items-center mr-2 mb-1">
          <span class="mr-50 card-label-bold">Enable Back To Home VPN:</span>
          <!-- Re-rendered after every click so that the switch always shows the router state, also when the action is cancelled or fails. -->
          <b-form-checkbox
            :key="switchKey"
            :checked="status.is_enabled"
            switch
            :disabled="!canToggle || toggling || (!status.is_enabled && !status.has_public_ip)"
            @change="toggle"
          />
          <b-spinner
            v-if="toggling"
            variant="primary"
            label="Spinning"
            small
          />
        </div>
        <div
          v-if="status.is_enabled"
          class="d-flex align-items-center mr-2 mb-1"
        >
          <span class="mr-50 card-label-bold">Status:</span>
          <b-badge
            pill
            :variant="status.is_running ? 'success' : 'warning'"
          >
            {{ status.is_running ? 'Running' : startingLabel }}
          </b-badge>
        </div>
        <div
          v-if="status.is_running && status.connection"
          class="d-flex align-items-center mr-2 mb-1"
        >
          <span class="mr-50 card-label-bold">Connection:</span>
          <span
            v-b-tooltip.hover
            :title="status.connection_status"
          >
            {{ status.connection === 'direct' ? 'Direct' : 'Via MikroTik relay' }}
          </span>
        </div>
        <div
          v-if="status.is_enabled && status.dns_name"
          class="d-flex align-items-center mr-2 mb-1"
        >
          <span class="mr-50 card-label-bold">VPN address:</span>
          <span>{{ status.dns_name }}</span>
        </div>
        <div class="d-flex align-items-center mb-1 text-muted">
          RouterOS {{ status.routeros_version }}
        </div>
      </div>
      <b-alert
        v-if="!status.has_public_ip"
        variant="warning"
        class="mb-1"
        show
      >
        <div class="alert-body">
          {{ status.public_ip_reason }}
          <template v-if="status.is_enabled">
            VPN users are paused until Public IP is back.
          </template>
        </div>
      </b-alert>
      <p
        v-if="!status.is_enabled"
        class="mb-0 text-muted"
      >
        Back To Home lets users reach this site over a WireGuard VPN from their phones and laptops.
        Each user gets their own config and QR code.
      </p>
      <b-alert
        v-if="status.is_enabled && status.warning"
        variant="secondary"
        class="mb-0"
        show
      >
        <div class="alert-body">
          {{ status.warning }}
        </div>
      </b-alert>
      <b-alert
        v-if="status.has_peer_toggle_issue"
        variant="warning"
        class="mt-1 mb-0"
        show
      >
        <div class="alert-body">
          RouterOS {{ status.routeros_version }} can leave a VPN tunnel broken after a user is disabled and enabled again.
          Update RouterOS to 7.24.1 or newer.
        </div>
      </b-alert>
    </template>
  </div>
</template>

<script>
import {
  BAlert, BBadge, BFormCheckbox, BSpinner, VBTooltip,
} from 'bootstrap-vue'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BAlert,
    BBadge,
    BFormCheckbox,
    BSpinner,
  },
  props: {
    status: {
      type: Object,
      default: null,
    },
    canToggle: {
      type: Boolean,
      default: false,
    },
    toggling: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      switchKey: 0,
    }
  },
  computed: {
    startingLabel() {
      const vpnStatus = this.status.vpn_status

      return vpnStatus ? `Starting: ${vpnStatus}` : 'Starting'
    },
  },
  methods: {
    toggle(isEnabled) {
      this.switchKey += 1
      this.$emit('toggle', isEnabled)
    },
  },
}
</script>
